import { observer } from 'mobx-react-lite';
import { AppName, Env } from 'src/core/Environment';
import { AgentTaskViewHeader } from 'src/pages/TasksPage/components/AgentTaskViewHeader';
import { BOTaskViewHeader } from 'src/pages/TasksPage/components/BOTaskViewHeader';

export const TaskViewHeader = observer(() => {
    if (Env.appName === AppName.AGENT_PORTAL) {
        return <AgentTaskViewHeader />;
    }

    return <BOTaskViewHeader />;
});
